import { QueryClient } from "@tanstack/react-query";

/** Shared QueryClient — plan/26 TanStack Query. */
export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
}
